<template>
  <div class="game mt-3">
    <h4 class="text-center">Putting pieces on the board...</h4>
  </div>
</template>

<script>
export default {
  name: 'gameRedirect',
  created() {
    this.$router.push(`/games/${this.$route.params.game_id}`);
  },
};
</script>
